export default "__VITE_ASSET__s5TgXsxo__"